<template>
  <v-card
    v-show="show"
    flat
    outlined
    tile
  >
    <v-card-text
      class="text-center text-h5"
    >
      <div>
        Template Settings are not configured for the store.
      </div>
      <div>
        <v-btn
          id="get-default_template"
          color="primary"
          text
          class="mt-2"
          @click="$emit('fetch')"
        >
          Get default template
        </v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
    name: "EmptyTemplate",
    props:{
        show: Boolean
    }
};
</script>